export default {
  email: 'Invalid email',
  required: 'Required',
  username: 'This is not a valid username',
}
